const DuplicateConfiguration = () =>
  import(
    /* webpackChunkName: "DuplicateConfiguration" */ `@/components/rapsotec/projects/project/configuration/DuplicateConfiguration.vue`
  );

const BatchesManagement = () =>
  import(
    /* webpackChunkName: "BatchesManagement" */ `@/components/rapsotec/projects/project/configuration/BatchesManagement.vue`
  );

export default [
  {
    path: "duplication",
    name: "duplicateConfiguration",
    component: DuplicateConfiguration,
  },
  {
    path: "batches",
    name: "batchesManagement",
    component: BatchesManagement,
  },
];
